import { ViteReactSSG } from 'vite-react-ssg';
import { routes } from './routes';
import './index.css';
import ProjectTracker from './utils/ProjectTracker';
import { CHUNK_RELOAD_FLAG } from './utils/lazyWithReload';

// Initialize project tracker (client-only side-effect)
if (typeof window !== 'undefined') {
  ProjectTracker.initialize();

  // Filet de sécurité : Vite émet `vite:preloadError` quand un module
  // dynamique (chunk) ne peut pas être chargé — typiquement un chunk périmé
  // après un déploiement. On recharge la page une fois (même flag que
  // lazyWithReload pour ne jamais boucler).
  window.addEventListener('vite:preloadError', (event) => {
    if (!sessionStorage.getItem(CHUNK_RELOAD_FLAG)) {
      // Empêche le rethrow par défaut de Vite : on gère via un rechargement,
      // inutile de faire clignoter l'erreur en console juste avant.
      event.preventDefault();
      sessionStorage.setItem(CHUNK_RELOAD_FLAG, '1');
      window.location.reload();
    }
  });
}

export const createRoot = ViteReactSSG({ routes });

/**
 * Exported so vite-react-ssg reads it at build time to determine which paths
 * to pre-render. Only public pages are included — backoffice and transactional
 * pages are excluded.
 */
export function includedRoutes(paths: string[]): string[] {
  // paths may or may not have a leading slash depending on the route tree depth
  return paths.filter((p) => {
    const normalised = p.startsWith('/') ? p : `/${p}`;
    return (
      !normalised.startsWith('/backoffice') &&
      !normalised.includes(':') &&
      normalised !== '/paiement'
    );
  });
}
